'use client';

// Recovered from the IMAI v5 animation source; demo documents stay illustrative.
import * as React from 'react';
import { ShowcaseCopyContext, translateShowcaseNode } from '../translation';
import { ue } from './reference-products';
import { ArtifactStatus, BlurSwap } from './playback-controls';
import { ec } from './production-briefs';
import {
  CollectionReveal,
  V,
  Scene_js,
  Scene_Ns,
  Scene_Ms,
  Ts,
} from './collection-artifact-primitives';
export const tc = [
  {
    key: 'A',
    name: ue.name,
    pieces: [0, 2, 5],
    evidence: [
      {
        text: 'Research reports chose a coat for the third tailoring piece.',
        meta: '4 of 5',
        pro: !0,
      },
      {
        text: 'Stock cloths and soft proportions.',
        pro: !0,
      },
      {
        text: 'A thin selvedge-inspired edge line instead of a logo.',
        pro: !0,
      },
    ],
    holds: 'Oxblood stays the only accent.',
  },
  {
    key: 'B',
    name: 'Engineered knit',
    tag: 'Gated',
    pieces: [4, 3, 1],
    evidence: [
      {
        text: 'More distinctive, knit-style construction.',
        pro: !0,
      },
      {
        text: 'Needs prototype testing first.',
        pro: !1,
      },
      {
        text: 'Unlikely to ship for FW27.',
        pro: !1,
      },
    ],
    holds: 'prototypes pass testing.',
  },
];
export const nc = [
  'Trends',
  'Audience',
  'Competitive',
  'Commercial',
  'Architecture',
];
export const rc = [300, 480];
export const ic = (e, t) => 900 + t * 600 + e * 260;
export const ac = [2900, 3100];
export const oc = 3600;
export const sc = 4300;
export const cc = 4450;
export function CollectionDirection({ t: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let t = e >= cc,
    n = e >= sc && e < cc;
  return (
    <div className={'flex h-full flex-col'}>
      <ArtifactStatus
        icon={'compass'}
        title={translateShowcaseNode(
          showcaseCopy,
          'FW27 direction: two routes'
        )}
        done={e >= ec}
        working={'Comparing routes'}
        doneLabel={'Direction set'}
      />
      <div className={'flex flex-1 flex-col gap-3 p-3 sm:p-5 md:gap-4 md:p-6'}>
        <div className={'flex flex-wrap items-center gap-1.5'}>
          <span className={'label mr-1'}>
            {translateShowcaseNode(showcaseCopy, 'Synthesised from')}
          </span>
          {translateShowcaseNode(
            showcaseCopy,
            nc.map((t, n) => (
              <CollectionReveal
                key={t}
                as={'span'}
                on={e >= 80 + n * 70}
                y={3}
                scale={0.97}
                className={
                  'text-ink-3 inline-flex h-6 items-center gap-1 rounded-full bg-[var(--tint)] px-2.5 text-[12px] leading-4'
                }
              >
                <span className={'num text-ink-2'}>
                  {translateShowcaseNode(showcaseCopy, 'R')}
                  {translateShowcaseNode(showcaseCopy, n + 1)}
                </span>
                <span className={'max-sm:hidden'}>
                  {translateShowcaseNode(showcaseCopy, t)}
                </span>
              </CollectionReveal>
            ))
          )}
        </div>
        <div className={'grid gap-3 md:grid-cols-2 md:gap-4'}>
          {translateShowcaseNode(
            showcaseCopy,
            tc.map((n, r) => {
              let i = t && r === 0,
                a = t && r !== 0;
              return (
                <CollectionReveal
                  key={n.key}
                  on={e >= (rc[r] ?? 0)}
                  scale={0.98}
                  className={'h-full'}
                >
                  <article
                    className={`sf relative flex h-full flex-col rounded-[14px] p-2 transition-[opacity,box-shadow] duration-300 ease-[var(--ease)] ${a ? 'opacity-45' : ''}`}
                    style={
                      i
                        ? {
                            boxShadow:
                              '0 0 0 1px color-mix(in oklch, var(--foreground) 45%, transparent), var(--shadow-minimal)',
                          }
                        : void 0
                    }
                  >
                    <div className={'grid grid-cols-3 gap-1'}>
                      {translateShowcaseNode(
                        showcaseCopy,
                        n.pieces.map((e, t) => {
                          let n = V[e];
                          return n ? (
                            <Scene_js
                              key={n.name}
                              piece={n}
                              className={`aspect-[2/1] transition-[filter] duration-300 md:aspect-[5/6] ${t === 0 ? 'rounded-l-[10px]' : ''} ${t === 2 ? 'rounded-r-[10px]' : ''} ${a ? 'saturate-[0.3]' : ''}`}
                            />
                          ) : null;
                        })
                      )}
                    </div>
                    <div className={'flex items-center gap-2 px-2 pt-3'}>
                      <span className={'text-ink-4 text-[12px]'}>
                        {translateShowcaseNode(showcaseCopy, 'Route ')}
                        {translateShowcaseNode(showcaseCopy, n.key)}
                      </span>
                      <h3
                        className={
                          'text-ink truncate text-[14.5px] leading-5 font-medium'
                        }
                      >
                        {translateShowcaseNode(showcaseCopy, n.name)}
                      </h3>
                      {translateShowcaseNode(
                        showcaseCopy,
                        n.tag ? (
                          <span
                            className={
                              'text-ink-3 inline-flex h-5 shrink-0 items-center rounded-[6px] px-1.5 text-[11px] shadow-[inset_0_0_0_1px_var(--line-strong)]'
                            }
                          >
                            {translateShowcaseNode(showcaseCopy, n.tag)}
                          </span>
                        ) : null
                      )}
                      <span
                        className={`ml-auto grid size-5 place-items-center rounded-full transition-[background-color,opacity] duration-200 ${i ? 'bg-[var(--primary)] text-[var(--primary-foreground)]' : 'opacity-0'}`}
                      >
                        <Scene_Ns on={i} className={'size-3.5'} />
                      </span>
                    </div>
                    <ul className={'flex flex-col gap-1.5 px-2 pt-2'}>
                      {translateShowcaseNode(
                        showcaseCopy,
                        n.evidence.map((t, n) => {
                          let i = e >= ic(r, n);
                          return (
                            <CollectionReveal
                              key={t.text}
                              as={'li'}
                              on={i}
                              y={3}
                              blur={2}
                              className={'flex items-start gap-2'}
                            >
                              <svg
                                viewBox={'0 0 20 20'}
                                aria-hidden={!0}
                                className={
                                  'text-ink-3 mt-[3px] size-3.5 shrink-0'
                                }
                              >
                                <Scene_Ms d={'M5 10h10'} on={i} ms={260} />
                                {translateShowcaseNode(
                                  showcaseCopy,
                                  t.pro ? (
                                    <Scene_Ms
                                      d={'M10 5v10'}
                                      on={i}
                                      ms={260}
                                      delay={120}
                                    />
                                  ) : null
                                )}
                              </svg>
                              <span className={'sr-only'}>
                                {translateShowcaseNode(
                                  showcaseCopy,
                                  t.pro ? 'For:' : 'Against:'
                                )}
                              </span>
                              <span
                                className={
                                  'text-ink-2 min-w-0 flex-1 text-[12.5px] leading-[18px]'
                                }
                              >
                                {translateShowcaseNode(showcaseCopy, t.text)}
                              </span>
                              {translateShowcaseNode(
                                showcaseCopy,
                                t.meta ? (
                                  <span
                                    className={
                                      'num text-ink-4 shrink-0 text-[11px] leading-[18px]'
                                    }
                                  >
                                    {translateShowcaseNode(
                                      showcaseCopy,
                                      t.meta
                                    )}
                                  </span>
                                ) : null
                              )}
                            </CollectionReveal>
                          );
                        })
                      )}
                    </ul>
                    <CollectionReveal
                      as={'p'}
                      on={e >= (ac[r] ?? 0)}
                      y={3}
                      className={
                        'text-ink-3 mt-auto px-2 pt-3 pb-1.5 text-[12px] leading-4'
                      }
                    >
                      <span className={'text-ink-2 font-medium'}>
                        {translateShowcaseNode(showcaseCopy, 'Holds if ')}
                      </span>
                      {translateShowcaseNode(showcaseCopy, n.holds)}
                    </CollectionReveal>
                  </article>
                </CollectionReveal>
              );
            })
          )}
        </div>
        <CollectionReveal
          on={e >= oc}
          y={6}
          className={
            'mt-auto flex min-h-10 flex-wrap items-center gap-x-3 gap-y-2 px-1'
          }
        >
          <span
            className={
              'text-ink-2 min-w-0 flex-1 basis-full text-[13px] leading-5 sm:basis-0'
            }
          >
            <BlurSwap
              value={
                t
                  ? `“${ue.name}” goes forward. Route B waits on prototypes.`
                  : 'Choose the route the line plan builds on.'
              }
            />
          </span>
          <span className={'flex gap-1.5'}>
            <span
              className={`btn btn-sm press ${t ? 'btn-ink' : 'btn-soft'}`}
              style={{
                transform: n ? 'scale(0.97)' : void 0,
              }}
            >
              {translateShowcaseNode(showcaseCopy, 'Go with A')}
            </span>
            <span
              className={`btn btn-sm btn-soft transition-opacity ${t ? 'opacity-45' : ''}`}
            >
              {translateShowcaseNode(showcaseCopy, 'Go with B')}
            </span>
          </span>
        </CollectionReveal>
      </div>
    </div>
  );
}
export const uc = 500 + V.length * 520 + 150;
export const dc = uc + 900;
export const fc = dc + 1100;
export const pc = [
  {
    key: 'style',
    letter: 'A',
    head: 'Style',
  },
  {
    key: 'role',
    letter: 'B',
    head: 'Role',
  },
  {
    key: 'category',
    letter: 'C',
    head: 'Category',
    wide: !0,
  },
  {
    key: 'price',
    letter: 'D',
    head: 'Proposed',
    short: 'Price',
    numeric: !0,
  },
  {
    key: 'options',
    letter: 'E',
    head: 'Options',
    numeric: !0,
  },
  {
    key: 'drop',
    letter: 'F',
    head: 'Drop',
    wide: !0,
  },
];
export const mc = (e, t) => 500 + e * 520 + t * 70;
export const hc = (e, t) => {
  let n = V[e];
  return n
    ? t === 'price'
      ? Ts(n.price)
      : t === 'options'
        ? String(n.options)
        : n[t]
    : '';
};
export const gc = (e) => V.filter((t, n) => e >= mc(n, pc.length - 1)).length;
export function _c(e) {
  let t = V.slice(0, gc(e)),
    n = t.reduce((e, t) => e + t.options, 0),
    r = t.length
      ? Math.round(t.reduce((e, t) => e + t.price, 0) / t.length)
      : 0;
  return {
    styles: t.length,
    options: n,
    avg: r,
  };
}
